<template>
  <atomic-link class="install-app-menu-item" @click="installApp">
    <template v-if="!isDrawerCompact">
      <span class="install-app-menu-item__text">
        {{ getContent(layoutData, defaultLocaleLayoutData, 'siteSidebar.installApp') }}
      </span>
      <div class="install-app-menu-item__icons">
        <atomic-icon id="apple" />
        <atomic-icon id="android" />
      </div>
    </template>

    <template v-else>
      <atomic-icon id="install-app" />
    </template>
  </atomic-link>
</template>

<script setup lang="ts">
  const globalStore = useGlobalStore();
  const { layoutData, defaultLocaleLayoutData } = storeToRefs(globalStore);
  const { getContent } = useProjectMethods();

  const installApp = (): void => {
    window.pwa?.install();
  };

  const layoutStore = useLayoutStore();
  const { isDrawerCompact } = storeToRefs(layoutStore);
</script>

<style src="~/assets/styles/components/atomic/menu/install-app.scss" lang="scss" />
